export default {
      id: "logo_dots_color-usage",
      viewBox: "0 0 116 30",
      url: __webpack_public_path__ + "sprite.svg#logo_dots_color",
      toString: function () {
        return this.url;
      }
    }